import { Component, ChangeDetectionStrategy } from "@angular/core";

/**
 * Display copyright message
 */
@Component({
  selector: "aa-copyright",
  templateUrl: "./copyright.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CopyrightComponent {
  public readonly year: number = new Date().getFullYear();
}
